import "core-js/modules/es6.string.ends-with";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.string.ends-with";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React from 'react';
import { Link } from 'gatsby';
import trackEvent from '../utils/track';

var PapertrailLink = function PapertrailLink(_ref) {
  var to = _ref.to,
      href = _ref.href,
      track = _ref.track,
      _onClick = _ref.onClick,
      props = _objectWithoutProperties(_ref, ["to", "href", "track", "onClick"]);

  var destination = href || to; // Tailor the following test to your environment.
  // This example assumes that any internal link (intended for Gatsby)
  // will start with exactly one slash, and that anything else is external.

  var internal = /^\/(?!\/)/.test(destination); // Use gatsby-link for internal links, and <a> for others

  if (internal && !destination.endsWith('.pdf')) {
    return React.createElement(Link, _extends({
      to: destination
    }, props, {
      onClick: function onClick(event) {
        if (_onClick) {
          _onClick(event);
        }

        if (track) {
          trackEvent(track);
        }
      }
    }));
  }

  return React.createElement("a", _extends({
    href: destination
  }, props, {
    onClick: function onClick(event) {
      if (_onClick) {
        _onClick(event);
      }

      if (track) {
        trackEvent(track);
      }
    }
  }));
};

export default PapertrailLink;